module.exports = __webpack_public_path__ + "static/img/u45.97a94e4d.png";